import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

function includeCSSfile(href) {
    var headNode = document.getElementsByTagName('head')[0];
    var linkTag = document.createElement('link');
    linkTag.setAttribute('rel', 'stylesheet');
    linkTag.setAttribute('type', 'text/css');
    linkTag.setAttribute('href', href);
    headNode.appendChild(linkTag);
}

function includeJsfile(src) {
    var headNode = document.getElementsByTagName('head')[0];
    var scriptElement = document.createElement('script');
    scriptElement.setAttribute('src', src);
    headNode.appendChild(scriptElement);
}

includeJsfile("https://www.google.com/recaptcha/api.js");
includeCSSfile('https://my.kabbalah.com/ticket-widget/css/main.latest.css');

const node = document.getElementById('tkc-widget-root');
const data = node.dataset.react ? JSON.parse(node.dataset.react) : {};
ReactDOM.render(<App data={data} />, node);

//ReactDOM.render(<App />, document.getElementById('root'));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js